interface PageMainTitle {
  category: string
  title: string
  sub_title: string
  sub_title2: string
  text: string
}

export const pageMainTitle: PageMainTitle = {
  category: '私たちについて',
  title: 'About',
  sub_title: '',
  sub_title2: '',
  text:
    '',
}
